import ExpediaTab from './ExpediaTab'

export default ExpediaTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/index.js